import React from 'react';

import Layout from '../components/Layout';
import Scroll from '../components/Scroll';

import config from '../../config';
import Footer from '../components/Footer';
import Header from '../components/Header';
import ScrollToTop from '../components/ScrollToTop';


import p4 from '../assets/images/he.gif';
import p5 from '../assets/images/h2.gif';
import p6 from '../assets/images/h3.gif';
import p7 from '../assets/images/h4.gif';


const IndexPage = () => (
  <Layout>
    <Header />

    <div className="col-lg-6">
            <a className="portfolio-item" href="#">
              <span className="caption">
                <span className="caption-content">
                  <h2></h2>
                  <p className="mb-0">
                  <b> <code>Everyday Health with just a click...</code></b>
                  </p>
                </span>
              </span>
              <img className="img-fluid" src={p4} alt="" />
            </a>


          </div>

   

    


    

    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.myfitnesspal.com/" className="btn btn-xl btn-light mr-4">
         MyFitnessPal
        </a>
        <a href="https://medlineplus.gov/" className="btn btn-xl btn-dark">
          MedlinePlus
        </a>
      </div>
    </section>




 <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.healthline.com/" className="btn btn-xl btn-light mr-4">
        Healthline
        </a>
        <a href="https://therealfoodrds.com/" className="btn btn-xl btn-dark">
          The Real Food Dietitians
        </a>
      </div>
    </section>


     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://familydoctor.org/" className="btn btn-xl btn-light mr-4">
        Family Doctor
        </a>
        <a href="https://www.livestrong.com/" className="btn btn-xl btn-dark">
          Livestrong 
        </a>
      </div>
    </section>


<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.drugs.com/" className="btn btn-xl btn-light mr-4">
         Drugs.com
        </a>
       <a href="https://www.yogajournal.com/" className="btn btn-xl btn-dark">
          Yoga Journal
        </a>
      </div>
    </section>

 




 <section className="content-section" id="portfolio">
      <div className="container">
        <div className="content-section-heading text-center">
          <h3 className="text-secondary mb-0">Browse Smartly</h3>
          <img className="img-fluid" src={p5} alt="" />
          <h2 className="mb-5">Food is Fuel.Not Therapy.<i className="fa fa-search-plus fa-spin"></i></h2>
        </div>
        
      </div>
    </section>









     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.wellandgood.com/" className="btn btn-xl btn-light mr-4">
       Well + Good       </a>
        <a href="https://www.diabetes.org/" className="btn btn-xl btn-dark">
        American Diabetes Association
        </a>
      </div>
    </section>






     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://greatist.com/" className="btn btn-xl btn-light mr-4">
         Greatist
        </a>
        <a href="https://fitbottomedgirls.com/" className="btn btn-xl btn-dark">
          Fit Bottomed Girls
        </a>
      </div>
    </section>





<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href=" https://breakingmuscle.com/" className="btn btn-xl btn-light mr-4">
        Breaking Muscle 
        </a>
        <a href="https://www.acefitness.org/" className="btn btn-xl btn-dark">
          ACE Fitness
        </a>
      </div>
    </section>





<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.womenshealthmag.com/" className="btn btn-xl btn-light mr-4">
        Women’s Health
        </a>
        <a href="https://avocadu.com/" className="btn btn-xl btn-dark">
         Avocadu
        </a>
      </div>
    </section>




 <section className="content-section" id="portfolio">
      <div className="container">
        <div className="content-section-heading text-center">
          <h3 className="text-secondary mb-0">Browse Smartly</h3>
          <img className="img-fluid" src={p6} alt="" />
          <h2 className="mb-5">The Greatest Wealth is Health<i className="fa fa-search-plus fa-spin"></i></h2>
        </div>
        
      </div>
    </section>





<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.verywellhealth.com/" className="btn btn-xl btn-light mr-4">
       Verywell Health
        </a>
        <a href=" https://www.olivemagazine.com/" className="btn btn-xl btn-dark">
         Olive Magazine
        </a>
      </div>
    </section>












<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.shape.com/" className="btn btn-xl btn-light mr-4">
       Shape
        </a>
        <a href="https://www.health.com/" className="btn btn-xl btn-dark">
         Health.com
        </a>
      </div>
    </section>


<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://artofhealthyliving.com/" className="btn btn-xl btn-light mr-4">
       the art of healthy living
        </a>
        <a href="https://www.prevention.com/" className="btn btn-xl btn-dark">
          Prevention
        </a>
      </div>
    </section>


<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://bitesofwellness.com/" className="btn btn-xl btn-light mr-4">
       Bites of Wellness
        </a>
        <a href="https://www.active.com/" className="btn btn-xl btn-dark">
       Active.com
        </a>
      </div>
    </section>



<section className="content-section" id="portfolio">
      <div className="container">
        <div className="content-section-heading text-center">
          <h3 className="text-secondary mb-0">Browse Smartly</h3>
          <img className="img-fluid" src={p7} alt="" />
          <h2 className="mb-5">Eat Less Sugar, You're Sweet Enough Already.<i className="fa fa-search-plus fa-spin"></i></h2>
        </div>
        
      </div>
    </section>





<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.eatingbirdfood.com/" className="btn btn-xl btn-light mr-4">
      Eating Bird Food

        </a>
        <a href="https://www.muscleandfitness.com/" className="btn btn-xl btn-dark">
          Muscle and Fitness
        </a>
      </div>
    </section>



    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://nutritionstripped.com/" className="btn btn-xl btn-light mr-4">
      Nutrition Stripped
        </a>
        <a href="https://www.ahealthysliceoflife.com/" className="btn btn-xl btn-dark">
          A Healthy Slice of Life
        </a>
      </div>
    </section>



    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.everydayhealth.com/" className="btn btn-xl btn-light mr-4">
       Everyday Health
        </a>
        <a href="https://yogalifestyles.com/" className="btn btn-xl btn-dark">
         Yoga Lifestyles
        </a>
      </div>
    </section>







    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.mantramagazine.com/" className="btn btn-xl btn-light mr-4">
      Mantra Wellness
        </a>
        <a href="https://www.cleaneatingmag.com/" className="btn btn-xl btn-dark">
        Clean Eating
        </a>
      </div>
    </section>








    {/* <section id="contact" className="map">
      <iframe
        width="100%"
        height="100%"
        frameborder="0"
        scrolling="no"
        marginheight="0"
        marginwidth="0"
        src="https://maps.google.com/maps?f=q&amp;source=s_q&amp;hl=en&amp;geocode=&amp;q=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;aq=0&amp;oq=twitter&amp;sll=28.659344,-81.187888&amp;sspn=0.128789,0.264187&amp;ie=UTF8&amp;hq=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;t=m&amp;z=15&amp;iwloc=A&amp;output=embed"
      ></iframe>
      <br />
      <small>
        <a href="https://maps.google.com/maps?f=q&amp;source=embed&amp;hl=en&amp;geocode=&amp;q=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;aq=0&amp;oq=twitter&amp;sll=28.659344,-81.187888&amp;sspn=0.128789,0.264187&amp;ie=UTF8&amp;hq=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;t=m&amp;z=15&amp;iwloc=A"></a>
      </small>
    </section> */}

    <ScrollToTop />
    <Footer />
  </Layout>
);

export default IndexPage;
